import moment from 'moment';
import { emailPattern, phonePattern, phonePatternLT, phonePatternLTWithZero } from './regexExpressions';

export const MIN_AGE_REQUIREMENT = 14;

export const normalizePhone = (value?: string | null) => (value ?? '').replace(/\s/g, '').trim();

export const isValidPhoneNumber = (value: string): boolean => {
  if (!value) {
    return false;
  }

  const normalizedPhone = normalizePhone(value);

  if (normalizedPhone.startsWith('+370')) {
    return phonePatternLT.test(normalizedPhone);
  } else if (normalizedPhone.startsWith('0')) {
    return phonePatternLTWithZero.test(normalizedPhone);
  }

  return phonePattern.test(normalizedPhone);
};

export const isValidEmail = (value: string): boolean => {
  return value && emailPattern.test(value);
};

export const isValidAge = (birthDate: moment.Moment | null): boolean => {
  if (!birthDate) {
    return true;
  }

  const today = moment();
  const age = today.diff(birthDate, 'years');

  return age >= MIN_AGE_REQUIREMENT;
};
